export default __webpack_public_path__ + "52aeda65532c950f1adae3fa328dd06c.png";